import React from 'react';
import {
  arrayOf,
  bool,
  func,
  node,
  oneOfType,
  shape,
  string
} from 'prop-types';
import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TabButton.scss';

export default class TabButton extends BaseComponent {
  render() {
    const {
      active,
      className,
      disabled,
      id,
      inner,
      onClick,
      style,
      title
    } = this.props;

    const classNames = ClassNames([
      'TabButton',
      'button',
      className,
      { active },
      { inner }
    ]);

    return (
      <button
        className={classNames}
        disabled={disabled}
        id={id}
        onClick={onClick}
        style={style}
        type="button"
      >
        <span className="button__content">{title}</span>
      </button>
    );
  }
}

TabButton.propTypes = {
  active: bool,
  className: string,
  disabled: bool,
  icon: string,
  id: string,
  inner: bool,
  onClick: func,
  style: shape({}),
  title: oneOfType([arrayOf(node), node, string])
};

TabButton.defaultProps = {
  active: false,
  className: undefined,
  disabled: undefined,
  icon: undefined,
  id: undefined,
  inner: false,
  onClick: undefined,
  style: undefined,
  title: undefined
};
